import React, { useContext, useEffect, useState } from 'react';

import { Link as RouterLink } from 'react-router-dom';

import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    IconButton,
    Link,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip,
    Typography
} from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';

import { stringToLocaleDateString } from '../../../../helpers';
import { UtenteLink } from '../../../common';
import { NavContext, NavRoutes } from "../../../contexts";
import { TipiUfficiContext } from '../TipiUfficiContext';

const LinkRouter = props => <Link {...props} component={RouterLink} />;

export const TipiList = ({
    searchText,
    itemsPerPage,
    disabled,
    onLoadMore,
    onExport,
    onImport,
    onActionClick,
    ...props
}) => {

    const {
        getRouteTo
    } = useContext(NavContext);

    const {
        state,
    } = useContext(TipiUfficiContext);

    const {
        tipiUffici
    } = state;

    const [pageIndex, setPageIndex] = useState(0);
    const pageIndexChangeHandler = (e, index) => {
        setPageIndex(index);
    }

    const deleteClickHandler = async (data) => {
        if (onActionClick)
            onActionClick("Delete", data);
    }

    const addNewClickHandler = () => {
        if (onActionClick)
            onActionClick("Add");

    }

    useEffect(() => {
        if (tipiUffici && onLoadMore) {
            onLoadMore(0, pageSize, searchText);
        }
    }, [searchText]);

    const [pageSize, setPageSize] = useState(itemsPerPage);
    const pageSizeChangeHandler = (e) => {
        setPageSize(e.target.value)
    }

    useEffect(() => {
        if (tipiUffici && onLoadMore) {
            onLoadMore(pageIndex, pageSize, searchText);
        }
    }, [pageIndex, pageSize]);

    return (
        <div>
            <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                sx={{ marginTop: 3 }}>
                {tipiUffici ? tipiUffici.totalCount : 0}&nbsp;Record trovati
            </Typography>
            <Card>
                <CardHeader
                    titleTypographyProps={{ variant: "h6" }}
                    title={
                        <Grid container justifyContent="space-between">
                            <Grid item>
                                <Typography variant="h6">
                                    Tutti i Ambiti
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    disableElevation
                                    color="info"
                                    onClick={addNewClickHandler}
                                >
                                    Aggiungi
                                </Button>
                            </Grid>
                        </Grid>
                    }
                    sx={{ backgroundColor: "secondary.main", color: "white" }}
                />
                <Divider />
                <CardContent sx={{ padding: 0 }}>
                    <Table>
                        <TableHead sx={{ backgroundColor: "aliceblue", }}>
                            <TableRow>
                                <TableCell style={{ width: "50%" }}>Nome</TableCell>
                                <TableCell style={{ width: "10%" }}>Ordine</TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Inserito da
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Modificato da
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Data inserimento
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Data Modifica
                                </TableCell>
                                <TableCell align="right"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tipiUffici && tipiUffici.result.length > 0
                                && tipiUffici.result.map((tipo, index) => {
                                    return (
                                        <TableRow hover key={index}>
                                            <TableCell>
                                                <div sx={{
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}>
                                                    <div>
                                                        <Link
                                                            color="textPrimary"
                                                            onClick={() => window.open(getRouteTo(NavRoutes.TipoUfficio, [tipo.id]), "_blank").focus()}
                                                            sx={{ fontWeight: 700, cursor: "pointer" }}>
                                                            {tipo.nome}
                                                        </Link>
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <Typography>
                                                    {tipo.ordine}
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="center">
                                                <UtenteLink utenteId={tipo?.creatoDa} />
                                            </TableCell>
                                            <TableCell align="center">
                                                <UtenteLink utenteId={tipo?.aggiornatoDa} />
                                            </TableCell>
                                            <TableCell align="center">
                                                {stringToLocaleDateString(tipo.dataCreazione)}
                                            </TableCell>
                                            <TableCell align="center">
                                                {stringToLocaleDateString(tipo.dataAggiornamento)}
                                            </TableCell>
                                            <TableCell align="right">
                                                <IconButton
                                                    aria-label="delete"
                                                    disabled={disabled}
                                                    onClick={() => deleteClickHandler(tipo)}>
                                                    <Tooltip title="elimina tipo">
                                                        <DeleteIcon />
                                                    </Tooltip>
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                            }
                        </TableBody>
                    </Table>
                </CardContent>
                <TablePagination
                    component="div"
                    count={tipiUffici ? tipiUffici.totalCount : 0}
                    onPageChange={pageIndexChangeHandler}
                    onRowsPerPageChange={pageSizeChangeHandler}
                    page={pageIndex}
                    rowsPerPage={pageSize}
                    rowsPerPageOptions={[5, 10, 25]}
                />
            </Card>
        </div>
    );
}